module.exports = __webpack_public_path__ + "img/sh.3baa44b6.webp";